(function ($) {
	if($('#locations-google-map').length) {
		var script = document.createElement('script');
		script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCoL0b-UijSmhuIbSMvJbU20yPBqd-iNo0&callback=initMap';
		script.async = true;

		window.initMap = function() {
		  	var map,
		  		marker,
		  		locationsMap = document.getElementById("locations-google-map"),
		  		latitude = parseFloat(locationsMap.dataset.lat),
		  		longitude = parseFloat(locationsMap.dataset.long);

			map = new google.maps.Map(locationsMap, {
			    center: { lat: latitude, lng: longitude },
			    zoom: 15,
			    styles: [
				    {
				        "featureType": "administrative",
				        "elementType": "all",
				        "stylers": [
				            {
				                "visibility": "on"
				            },
				            {
				                "lightness": 33
				            }
				        ]
				    },
				    {
				        "featureType": "landscape",
				        "elementType": "all",
				        "stylers": [
				            {
				                "color": "#f7f7f7"
				            }
				        ]
				    },
				    {
				        "featureType": "poi.business",
				        "elementType": "all",
				        "stylers": [
				            {
				                "visibility": "off"
				            }
				        ]
				    },
				    {
				        "featureType": "poi.park",
				        "elementType": "geometry",
				        "stylers": [
				            {
				                "color": "#deecdb"
				            }
				        ]
				    },
				    {
				        "featureType": "poi.park",
				        "elementType": "labels",
				        "stylers": [
				            {
				                "visibility": "on"
				            },
				            {
				                "lightness": "25"
				            }
				        ]
				    },
				    {
				        "featureType": "road",
				        "elementType": "all",
				        "stylers": [
				            {
				                "lightness": "25"
				            }
				        ]
				    },
				    {
				        "featureType": "road",
				        "elementType": "labels.icon",
				        "stylers": [
				            {
				                "visibility": "off"
				            }
				        ]
				    },
				    {
				        "featureType": "road.highway",
				        "elementType": "geometry",
				        "stylers": [
				            {
				                "color": "#ffffff"
				            }
				        ]
				    },
				    {
				        "featureType": "road.highway",
				        "elementType": "labels",
				        "stylers": [
				            {
				                "saturation": "-90"
				            },
				            {
				                "lightness": "25"
				            }
				        ]
				    },
				    {
				        "featureType": "road.arterial",
				        "elementType": "all",
				        "stylers": [
				            {
				                "visibility": "on"
				            }
				        ]
				    },
				    {
				        "featureType": "road.arterial",
				        "elementType": "geometry",
				        "stylers": [
				            {
				                "color": "#ffffff"
				            }
				        ]
				    },
				    {
				        "featureType": "road.local",
				        "elementType": "geometry",
				        "stylers": [
				            {
				                "color": "#ffffff"
				            }
				        ]
				    },
				    {
				        "featureType": "transit.line",
				        "elementType": "all",
				        "stylers": [
				            {
				                "visibility": "off"
				            }
				        ]
				    },
				    {
				        "featureType": "transit.station",
				        "elementType": "all",
				        "stylers": [
				            {
				                "visibility": "off"
				            }
				        ]
				    },
				    {
				        "featureType": "water",
				        "elementType": "all",
				        "stylers": [
				            {
				                "visibility": "on"
				            },
				            {
				                "color": "#e0f1f9"
				            }
				        ]
				    }
				]
			});

			var svgMarker = {
			    path: "M16 0c-6.627 0-12 5.373-12 12 0 12 12 20 12 20s12-8 12-20c0-6.627-5.373-12-12-12zM16 14c-2.209 0-4-1.791-4-4s1.791-4 4-4c2.209 0 4 1.791 4 4s-1.791 4-4 4z",
			    fillColor: "#0F8800",
			    fillOpacity: 1,
			    strokeWeight: 0,
			    rotation: 0,
			    scale: 1,
			    anchor: new google.maps.Point(0, 0),
		  	};

			marker = new google.maps.Marker({
			    position: { lat: latitude, lng: longitude },
			    icon: svgMarker,
			    map: map,
			});
		};

		document.head.appendChild(script);
	}
})(jQuery);